const COMMUNITY_API_BASE_URL =
  process.env.REACT_APP_COMMUNITY_API_BASE_URL
  || process.env.REACT_APP_API_BASE_URL
  || "";

export async function communityFetch(path, token, options = {}) {
  if (!COMMUNITY_API_BASE_URL) {
    throw new Error("Missing REACT_APP_COMMUNITY_API_BASE_URL");
  }
  if (!token) {
    throw new Error("Not signed in");
  }

  const response = await fetch(`${COMMUNITY_API_BASE_URL}${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      ...(options.headers || {}),
    },
  });

  const body = await response.json();
  if (!response.ok) {
    throw new Error(body.error || body.message || "Request failed");
  }
  return body;
}
